import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "form-group mb-3 row" }
const _hoisted_3 = { class: "input-group col" }
const _hoisted_4 = { class: "input-group col" }
const _hoisted_5 = { class: "form-group form-check mb-2" }
const _hoisted_6 = {
  class: "icon-container d-inline-block ml-2",
  title: "Dynamic mode: every parent's task_runs must share a common ancestor task_run (such as a spawner task), and this multi data task is enqueued once all children of that ancestor have completed. All parents in a single rule are either dynamic (this box ticked) or static (unticked) — the two can't be mixed. If you need one parent that's dynamic and another that's static, chain two rules. Dynamic rules group only on the Match Parents tags, so Sensor Tags Broadcast is hidden while this is ticked."
}
const _hoisted_7 = {
  key: 0,
  class: "form-group mb-3"
}
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = { class: "form-group mb-3" }
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = { class: "text h6 mb-2" }
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "table table-sm mb-1"
}
const _hoisted_15 = ["for"]
const _hoisted_16 = ["id", "onUpdate:modelValue"]
const _hoisted_17 = ["value"]
const _hoisted_18 = ["for"]
const _hoisted_19 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_20 = ["value", "title"]
const _hoisted_21 = ["for"]
const _hoisted_22 = ["id", "onUpdate:modelValue"]
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_25 = { class: "text-right" }
const _hoisted_26 = ["aria-label", "onClick"]
const _hoisted_27 = {
  key: 1,
  class: "text-muted small mb-1 pl-1"
}
const _hoisted_28 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TagMultiPicker = _resolveComponent("TagMultiPicker")!
  const _component_TagSinglePicker = _resolveComponent("TagSinglePicker")!
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text h5" }, "Join Configuration (shared between all parents)", -1)),
    _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-muted small mb-2" }, " Applies to every parent as a base scope. When a parent also has its own Sensor Tags filter (below), both are applied: the sensor must satisfy this rule-wide filter AND the parent's filter. ", -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "d-flex align-items-center mb-1" }, [
        _createElementVNode("div", { class: "input-group-text" }, "Sensor Tags (shared)")
      ], -1)),
      _createVNode(_component_TagMultiPicker, {
        "tag-sets": _ctx.tagSets,
        "sensor-tag-options": _ctx.sensorTagOptions,
        "key-prefix": "shared-",
        "aria-context": "from shared sensor tags"
      }, null, 8, ["tag-sets", "sensor-tag-options"])
    ]),
    _createVNode(_component_TagSinglePicker, {
      "model-value": _ctx.joinConfig.filter_to_same,
      "onUpdate:modelValue": _ctx.updateFilterToSame,
      "sensor-tag-options": _ctx.sensorTagOptions,
      label: "filter_to_same",
      "input-id": "join-filter-to-same",
      "label-title": "Sensor-tag names every parent must Match on. Pick each tag from the dropdown; the sensor tag registry drives the options.",
      "help-text": _ctx.filterToSameHelp,
      "remove-aria-label": (t) => `Remove filter_to_same tag ${t}`
    }, null, 8, ["model-value", "onUpdate:modelValue", "sensor-tag-options", "help-text", "remove-aria-label"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("label", {
          class: "input-group-text",
          for: "join-timeout",
          title: "Wait for MISSING parents to show up. Measured per group from the first parent's ended_at. Once this many minutes have passed, if the successful fraction meets min_success_fraction the group partial-fires; otherwise it's dropped. Applies at the group level, independent of any per-parent retry wait."
        }, " hard_timeout_minutes ", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "join-timeout",
          class: "form-control",
          type: "number",
          min: "1",
          step: "1",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.joinConfig.timeout_minutes) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.joinConfig.timeout_minutes,
            void 0,
            { number: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[7] || (_cache[7] = _createElementVNode("label", {
          class: "input-group-text",
          for: "join-min-success",
          title: "Fraction of parents that must succeed / be present before the join fires (0, 1]"
        }, " min_success_fraction ", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "join-min-success",
          class: "form-control",
          type: "number",
          min: "0.01",
          max: "1",
          step: "0.01",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.joinConfig.min_success_fraction) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.joinConfig.min_success_fraction,
            void 0,
            { number: true }
          ]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        id: "join-share-grandparent",
        type: "checkbox",
        class: "form-check-input",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.joinConfig.share_grandparent) = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.joinConfig.share_grandparent]
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("label", {
        class: "form-check-label",
        for: "join-share-grandparent",
        title: "Group by grandparent task_run (dynamic mode) instead of purely by filter_to_same tags"
      }, " dynamic_multi_data_task ", -1)),
      _createElementVNode("span", _hoisted_6, [
        _createVNode(_component_vue_feather, {
          type: "info",
          size: "16"
        })
      ])
    ]),
    (_ctx.joinConfig.share_grandparent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[9] || (_cache[9] = _createElementVNode("label", {
              class: "input-group-text",
              for: "join-gp-timeout",
              title: "How long to wait for the shared grandparent to finish producing new upstreams"
            }, " grandparent_timeout_minutes ", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "join-gp-timeout",
              class: "form-control",
              type: "number",
              min: "1",
              step: "1",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.joinConfig.grandparent_timeout_minutes) = $event))
            }, null, 512), [
              [
                _vModelText,
                _ctx.joinConfig.grandparent_timeout_minutes,
                void 0,
                { number: true }
              ]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[10] || (_cache[10] = _createElementVNode("label", {
          class: "input-group-text",
          for: "join-retry-grace",
          title: "Wait for THIS parent's retry to catch up. Per parent task_run: when one has errored and is still retryable, it's treated as not-yet-terminal for this many minutes after its ended_at, so the retry loop has time to spawn the retry and the join sees the retried run instead of prematurely declaring the parent failed. Only meaningful for task_rule parents — raw parents (bursts/data/results) don't retry."
        }, " parent_retry_timeout_minutes ", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "join-retry-grace",
          class: "form-control",
          type: "number",
          min: "0",
          step: "1",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.joinConfig.retry_grace_minutes) = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.joinConfig.retry_grace_minutes,
            void 0,
            { number: true }
          ]
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parents, (parent) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `cfg-${parent.id}`,
        class: "parent-card border p-2 mb-3"
      }, [
        _createElementVNode("div", _hoisted_11, " Parent P" + _toDisplayString(parent.id) + " Config (" + _toDisplayString(_ctx.parentDisplayName(parent)) + ") ", 1),
        _createElementVNode("div", _hoisted_12, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "input-group-text mb-1" }, "Sensor Tags Filter", -1)),
          _createVNode(_component_TagMultiPicker, {
            "tag-sets": parent.tagSets,
            "sensor-tag-options": _ctx.sensorTagOptions,
            "key-prefix": `p${parent.id}-`,
            "aria-context": `on parent P${parent.id}`
          }, null, 8, ["tag-sets", "sensor-tag-options", "key-prefix", "aria-context"])
        ]),
        (!_ctx.joinConfig.share_grandparent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"mb-1\" data-v-1b2fa2f2><div class=\"input-group-text d-inline-block\" data-v-1b2fa2f2>Sensor Tags Broadcast</div></div><p class=\"text-muted small mb-1\" data-v-1b2fa2f2> How the task runs of this parent are joined with task runs from other parents to form inputs to the multi data task runs. Options: Combine (default for unlisted tags), Split, Match(Pn). </p><details class=\"broadcast-details mb-2\" data-v-1b2fa2f2><summary class=\"text-primary small\" data-v-1b2fa2f2>Expand for details</summary><div class=\"small text-muted mt-2 pl-2 broadcast-details-content\" data-v-1b2fa2f2><p class=\"mb-2\" data-v-1b2fa2f2> Example: one rule with parents x and y, each producing one task run per Blade value (A, B, C) in the same origin, with Blade as the only grouping dimension. A child task run&#39;s inputs are written as e.g. (xA, yB) — a task run of x with Blade=A joined with a task run of y with Blade=B. The per-parent Blade action on each side can be Combine, Split, or Match(target). Enumerating the (x action, y action) pairs: </p><ol class=\"pl-3 mb-2\" data-v-1b2fa2f2><li class=\"mb-2\" data-v-1b2fa2f2><strong data-v-1b2fa2f2>(Combine, Combine)</strong> — rejected at save unless another grouping dimension exists. With one: a single group per origin; both parents broadcast every task run into it. <ul class=\"pl-3 mb-0\" data-v-1b2fa2f2><li data-v-1b2fa2f2>Child: (xA, xB, xC, yA, yB, yC)</li></ul> Output sensor: no Blade tag, as the inputs are on different blades. </li><li class=\"mb-2\" data-v-1b2fa2f2><strong data-v-1b2fa2f2>(Split, Split)</strong> — both parents own a per-parent Blade dimension; Cartesian product. <ul class=\"pl-3 mb-0\" data-v-1b2fa2f2><li data-v-1b2fa2f2>(xA, yA), (xA, yB), (xA, yC)</li><li data-v-1b2fa2f2>(xB, yA), (xB, yB), (xB, yC)</li><li data-v-1b2fa2f2>(xC, yA), (xC, yB), (xC, yC)</li></ul> Output sensor: tagged <code data-v-1b2fa2f2>Blades</code> (plural), x&#39;s blade then y&#39;s, e.g. <code data-v-1b2fa2f2>Blades: AB</code> for (xA, yB). </li><li class=\"mb-2\" data-v-1b2fa2f2><strong data-v-1b2fa2f2>(Combine, Split)</strong> — y owns the dimension; x is agnostic and broadcasts into every y group. <ul class=\"pl-3 mb-0\" data-v-1b2fa2f2><li data-v-1b2fa2f2>Group Blade=A: (xA, xB, xC, yA)</li><li data-v-1b2fa2f2>Group Blade=B: (xA, xB, xC, yB)</li><li data-v-1b2fa2f2>Group Blade=C: (xA, xB, xC, yC)</li></ul> Output sensor: tagged with the group&#39;s blade, e.g. <code data-v-1b2fa2f2>Blade: B</code>. </li><li class=\"mb-2\" data-v-1b2fa2f2><strong data-v-1b2fa2f2>(Split, Combine)</strong> — symmetric to the previous case. <ul class=\"pl-3 mb-0\" data-v-1b2fa2f2><li data-v-1b2fa2f2>Group Blade=A: (xA, yA, yB, yC)</li><li data-v-1b2fa2f2>Group Blade=B: (xB, yA, yB, yC)</li><li data-v-1b2fa2f2>Group Blade=C: (xC, yA, yB, yC)</li></ul> Output sensor: tagged with the group&#39;s blade, e.g. <code data-v-1b2fa2f2>Blade: B</code>. </li><li class=\"mb-2\" data-v-1b2fa2f2><strong data-v-1b2fa2f2>Match (any single direction)</strong> — aligned groups. (Match y, Split), (Split, Match x), (Match y, Combine) and (Combine, Match x) all collapse to this, because Match implicitly promotes its target to Split. <ul class=\"pl-3 mb-0\" data-v-1b2fa2f2><li data-v-1b2fa2f2>(xA, yA), (xB, yB), (xC, yC)</li></ul> i.e. is the same as the filter_to_same argument, but applied to two parents instead of all parents at once. Output sensor: tagged with the group&#39;s blade, e.g. <code data-v-1b2fa2f2>Blade: B</code>. </li><li class=\"mb-2\" data-v-1b2fa2f2><strong data-v-1b2fa2f2>(Match y, Match x)</strong> — rejected at save: mutual Match forms a self-referential cycle on Blade. </li></ol><p class=\"mb-0\" data-v-1b2fa2f2> Four distinct behaviours fall out: <em data-v-1b2fa2f2>broadcast all</em> (1), <em data-v-1b2fa2f2>Cartesian</em> (2), <em data-v-1b2fa2f2>mixed broadcast</em> (3 and 4), and <em data-v-1b2fa2f2>aligned</em> (5). Setting <code data-v-1b2fa2f2>Blade</code> in the rule-level filter_to_same list is equivalent to the aligned case without needing a per-parent row. </p><p class=\"mb-0 mt-2\" data-v-1b2fa2f2> Output sensors: tasks built on ga11ium&#39;s multi data task helpers tag their outputs with the tags that all of the run&#39;s inputs have in common, plus one tag per grouping dimension. A filter_to_same tag keeps its name and value (e.g. <code data-v-1b2fa2f2>Asset: T1</code>). A tag Split by one parent, or Matched to it, is written as that tag (<code data-v-1b2fa2f2>Blade: B</code>). A tag Split by several parents is written in the plural, with their values in parent order (<code data-v-1b2fa2f2>Blades: AB</code>). So each group has its own output sensors, which every run of that group adds to. </p></div></details>", 3)),
              (parent.tagActions.length > 0)
                ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
                    _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { scope: "col" }, "Tag"),
                        _createElementVNode("th", { scope: "col" }, "Action"),
                        _createElementVNode("th", { scope: "col" }, "Match Target"),
                        _createElementVNode("th", {
                          scope: "col",
                          class: "text-right"
                        }, "Remove")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parent.tagActions, (row, rIdx) => {
                        return (_openBlock(), _createElementBlock("tr", { key: rIdx }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("label", {
                              class: "sr-only",
                              for: `p${parent.id}-r${rIdx}-tag`
                            }, "Tag", 8, _hoisted_15),
                            _withDirectives(_createElementVNode("select", {
                              id: `p${parent.id}-r${rIdx}-tag`,
                              class: "form-control form-control-sm",
                              "onUpdate:modelValue": ($event: any) => ((row.tag) = $event)
                            }, [
                              _cache[12] || (_cache[12] = _createElementVNode("option", { value: "" }, "— Select —", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableBroadcastTagsFor(parent, row), (tagName) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: tagName,
                                  value: tagName
                                }, _toDisplayString(tagName), 9, _hoisted_17))
                              }), 128))
                            ], 8, _hoisted_16), [
                              [_vModelSelect, row.tag]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("label", {
                              class: "sr-only",
                              for: `p${parent.id}-r${rIdx}-action`
                            }, "Action", 8, _hoisted_18),
                            _withDirectives(_createElementVNode("select", {
                              id: `p${parent.id}-r${rIdx}-action`,
                              class: "form-control form-control-sm",
                              "onUpdate:modelValue": ($event: any) => ((row.action) = $event),
                              onChange: ($event: any) => (_ctx.onTagActionChange(row))
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagActionOptions, (a) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: a,
                                  value: a,
                                  title: _ctx.tagActionTitles[a]
                                }, _toDisplayString(a), 9, _hoisted_20))
                              }), 128))
                            ], 40, _hoisted_19), [
                              [_vModelSelect, row.action]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            (row.action === 'match')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("label", {
                                    class: "sr-only",
                                    for: `p${parent.id}-r${rIdx}-pn`
                                  }, "Match target", 8, _hoisted_21),
                                  _withDirectives(_createElementVNode("select", {
                                    id: `p${parent.id}-r${rIdx}-pn`,
                                    class: "form-control form-control-sm",
                                    "onUpdate:modelValue": ($event: any) => ((row.pn) = $event)
                                  }, [
                                    _cache[13] || (_cache[13] = _createElementVNode("option", { value: '' }, "— Select —", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherParentIds(parent), (pid) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: pid,
                                        value: pid
                                      }, " P" + _toDisplayString(pid), 9, _hoisted_23))
                                    }), 128))
                                  ], 8, _hoisted_22), [
                                    [
                                      _vModelSelect,
                                      row.pn,
                                      void 0,
                                      { number: true }
                                    ]
                                  ])
                                ], 64))
                              : (_openBlock(), _createElementBlock("span", _hoisted_24, "—"))
                          ]),
                          _createElementVNode("td", _hoisted_25, [
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-outline-danger",
                              type: "button",
                              "aria-label": `Remove broadcast row ${rIdx + 1} on parent P${parent.id}`,
                              onClick: ($event: any) => (_ctx.removeParentTagAction(parent, rIdx))
                            }, [
                              _createVNode(_component_vue_feather, {
                                type: "trash",
                                size: "14"
                              })
                            ], 8, _hoisted_26)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_27, " No broadcast entries. Tags not listed default to Combine (broadcast across every observed value). ")),
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-secondary",
                type: "button",
                onClick: ($event: any) => (_ctx.addParentTagAction(parent))
              }, [
                _createVNode(_component_vue_feather, {
                  type: "plus",
                  size: "14"
                }),
                _cache[15] || (_cache[15] = _createTextVNode(" Add row ", -1))
              ], 8, _hoisted_28)
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}